import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import axiosInstance from "../../axiosInstance";

function Signup() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [isVerificationStep, setIsVerificationStep] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const history = useHistory();

  const validateForm = () => {
    if (!firstName.trim()) {
      setError("First name is required.");
      return false;
    }
    if (!lastName.trim()) {
      setError("Last name is required.");
      return false;
    }
    
    { /*

    const regex = /^[A-Za-z]+$/;
    if (!regex.test(firstName) || !regex.test(lastName)) {
      setError('Only alphabets allowed for name')
      return false;
    }

    */ }
    
    if (!email.trim() || !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setError("Valid email is required.");
      return false;
    }
    if (!phone.trim() || !/^\d+$/.test(phone)) {
      setError("Valid phone number is required.");
      return false;
    }
    if (!password.trim() || password.length < 6) {
      setError("Password must be at least 6 characters long.");
      return false;
    }
    return true;
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!validateForm()) {
      return;
    }

    try {
      const response = await axiosInstance.post("/users/register", {
        firstName,
        lastName,
        email,
        phone,
        password,
      });

      if (response.data.success) {
        setIsVerificationStep(true);
        setSuccess("Registration successful! Please enter the verification code sent to your email.");
      } else {
        setError(response.data.error.message || "Registration failed!");
      }
    } catch (err) {
      setError(err.response?.data?.error?.message || "An error occurred during registration.");
    }
  };

  // Handle Google Signup Success
  const handleGoogleSuccess = async (credentialResponse) => {
    const { credential } = credentialResponse;
    try {
      const res = await axiosInstance.post("/users/googleAuth", { token: credential });
      if (res.data.success) {
        localStorage.setItem("token", res.data.data.token);
        history.push("/");
      }
    } catch (error) {
      setError("Google Signup failed. Please try again.");
    }
  };

  const handleVerification = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!verificationCode.trim() || verificationCode.length !== 4) {
      setError("Valid 4-digit verification code is required.");
      return;
    }

    try {
      const response = await axiosInstance.post("/users/validateConfirmationToken", {
        email,
        token: verificationCode,
      });

      if (response.data.success) {
        setSuccess("Email verified successfully! You can now log in.");
        history.push("/auth/login");
      } else {
        setError(response.data.error.message || "Verification failed!");
      }
    } catch (err) {
      setError(err.response?.data?.error?.message || "An error occurred during verification.");
    }
  };

  return (
    <Col md={5} className="p-5 bg-white full-height">
      <div className="login-main-left">
        <div className="text-center mb-5 login-main-left-header pt-4">
          <a href="https://autotrak.ai/">
          <img src="/img/logo-autotrak.png" className="img-fluid" alt="LOGO" />
          </a>
        </div>

        {isVerificationStep ? (
          <Form onSubmit={handleVerification}>
            <Form.Group>
              <Form.Label>Verification Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter the 4-digit code"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
              />
            </Form.Group>

            <div className="mt-4">
              <Button variant="outline-primary" size="lg" block type="submit">
                Verify
              </Button>
            </div>

            {error && <p className="text-danger mt-3">{error}</p>}
            {success && <p className="text-success mt-3">{success}</p>}
          </Form>
        ) : (
          <Form onSubmit={handleSignup}>
            <Form.Group>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your first name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your last name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your phone number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <div className="mt-4">
              <Row>
                <Col>
                  <Button variant="outline-primary" size="lg" block type="submit">
                    Sign Up
                  </Button>
                </Col>
              </Row>
            </div>

            {/* Google Signup Button
            <div className="mt-3 text-center">
              <GoogleOAuthProvider clientId="93558665157-s0oosl8ca1rf7ed69a18120a84sn11qu.apps.googleusercontent.com">
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={() => setError("Google signup failed. Please try again.")}
                />
              </GoogleOAuthProvider>
            </div> */}

            {error && <p className="text-danger mt-3">{error}</p>}
            {success && <p className="text-success mt-3">{success}</p>}
          </Form>
        )}

        <div className="text-center mt-5">
          <p className="light-gray">
            Already have an account? <Link to="/auth/login">Log In</Link>
          </p>
        </div>
      </div>
    </Col>
  );
}

export default Signup;
